'use client'
import React, { createContext, useContext, useCallback, useState, useMemo } from 'react';
import { toast } from "sonner";
import { ErrorCode, ERROR_MESSAGES } from '@/types/error';
import { ErrorContextType } from '@/types/contexts';

export const ErrorContext = createContext<ErrorContextType>({
  error: null,
  handleError: (code: ErrorCode) => {
    console.warn('⚠️ ErrorContextがProvider外で使用されています。ErrorProviderでラップしてください。', 'エラーコード:', code);
  },
  clearError: () => {
    console.warn('⚠️ ErrorContextがProvider外で使用されています。ErrorProviderでラップしてください。');
  },
});

export const ErrorProvider = ({ children }: { children: React.ReactNode }) => {
  const [error, setError] = useState<ErrorCode | null>(null);

  const handleError = useCallback((code: ErrorCode) => {
    console.error('エラーが発生しました:', ERROR_MESSAGES[code]);
    setError(code);

    // ユーザーへの通知
    toast.error(ERROR_MESSAGES[code]);
  }, []);

  const clearError = useCallback(() => {
    setError(null);
  }, []);

  const value = useMemo(() => ({
    error,
    handleError,
    clearError,
  }), [error, handleError, clearError]);

  return (
    <ErrorContext.Provider value={value}>
      {children}
    </ErrorContext.Provider>
  );
};

export const useError = () => {
  const context = useContext(ErrorContext);
  if (!context) {
    throw new Error('useErrorは必ずErrorProviderの中で使用してください');
  }
  return context;
};
